<script>
    export let url = '';

    url = encodeURIComponent(url || window.location.href);
</script>

<iframe
    src="https://www.facebook.com/plugins/share_button.php?href={url}&layout=button_count&size=large&width=110&height=28&appId"
    width="110"
    height="28"
    style="border:none;overflow:hidden"
    scrolling="no"
    frameborder="0"
    allowfullscreen="true"
    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
    title="Facebook Share"
></iframe>